const navLinks = [
  { label: '회사 소개', href: '#about' },
  { label: '사업 분야', href: '#business' },
  { label: '파트너', href: '#partners' },
  { label: '문의하기', href: '#contact' },
];

const businessAreas = [
  '의료장비 해외공급',
  '비전 인스펙션 솔루션',
  '초소형 헤드분리형 카메라',
  '글로벌 비즈니스 컨설팅',
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A2530] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-5">
              <img
                src="https://public.readdy.ai/ai/img_res/c9e35ef3-6870-488e-85b2-c6c685056c55.png"
                alt="Fixcope"
                className="h-8 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-xs">
              기술과 신뢰로 연결하는 글로벌 솔루션 파트너.<br />
              산업용 비전 인스펙션, 의료장비 글로벌 공급, 초소형 특수 카메라 개발, 해외진출 컨설팅을 진행하는 종합 기술 솔루션 기업입니다.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-mail-line text-[#FF8C3A]"></i>
                <span>info@fixcope.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-global-line text-[#FF8C3A]"></i>
                <span>www.fixcope.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-map-pin-2-line text-[#FF8C3A]"></i>
                <span>서울특별시 법원로11길7, 320호</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5 whitespace-nowrap">메뉴</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-sm text-gray-300 hover:text-[#FF8C3A] transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Business Areas */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5 whitespace-nowrap">사업 분야</h4>
            <ul className="space-y-3">
              {businessAreas.map((area, i) => (
                <li key={i}>
                  <button
                    onClick={() => handleNavClick('#business')}
                    className="text-sm text-gray-300 hover:text-[#FF8C3A] transition-colors text-left cursor-pointer"
                  >
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Large text */}
        <div className="overflow-hidden py-6 border-t border-white/5">
          <div className="text-[36px] sm:text-[52px] md:text-[80px] lg:text-[100px] font-bold text-white/5 tracking-tight leading-none select-none">
            FIXCOPE INC
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 border-t border-white/10">
          <p className="text-xs text-gray-500">
            © 2026 Fixcope. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
          </div>
        </div>
      </div>
    </footer>
  );
}
